import { createActions, handleActions } from 'redux-actions';
import { fromJS } from 'immutable';

const defaultState = {};


export class dbOptions {
    constructor() {
        this._options = {};
    }

    _asObj() {
        return this._options;
    }

    sort(type, value) {
        this._options.sort = { type, value };
        return this;
    }

    filter(type, value) {
        this._options.filter = { type, value };
        return this;
    }
}

dbOptions.build = () => new dbOptions();

dbOptions.SORT = Object.freeze({
    BY_CHILD: 'BY_CHILD',
    BY_KEY: 'BY_KEY',
    BY_VALUE: 'BY_VALUE',
});

dbOptions.FILTER = Object.freeze({
    LIMIT_TO_FIRST: 'LIMIT_TO_FIRST',
    LIMIT_TO_LIST: 'LIMIT_TO_LIST',
    START_AT: 'START_AT',
    END_AT: 'END_AT',
    EQUAL_TO: 'EQUAL_TO',
});

function applyOptions(ref, options) {
    let result = ref;
    if (options && options._asObj) {
        const opts = options._asObj();

        if (opts.sort) {
            switch (opts.sort.type) {
                case dbOptions.SORT.BY_CHILD:
                    result = result.orderByChild(opts.sort.value);
                    break;
                case dbOptions.SORT.BY_KEY:
                    result = result.orderByKey();
                    break;
                case dbOptions.SORT.BY_VALUE:
                    result = result.orderByValue();
                    break;
                default: break;
            }
        }
        if (opts.filter) {
            switch (opts.filter.type) {
                case dbOptions.FILTER.LIMIT_TO_FIRST:
                    result = result.limitToFirst(opts.filter.value);
                    break;
                case dbOptions.FILTER.LIMIT_TO_LIST:
                    result = result.limitToLast(opts.filter.value);
                    break;
                case dbOptions.FILTER.START_AT:
                    result = result.startAt(opts.filter.value);
                    break;
                case dbOptions.FILTER.END_AT:
                    result = result.endAt(opts.filter.value);
                    break;
                case dbOptions.FILTER.EQUAL_TO:
                    result = result.equalTo(opts.filter.value);
                    break;
                default: break;
            }
        }
    }

    return result;
}


export const dbActions = createActions({
    FIREBASE: {
        DATABASE: {
            GET: (ref, options = {}) => ({ ref, options }),
            SUBSCRIBE: (ref, options = {}) => ({ ref, options }),
            UNSUBSCRIBE: (ref) => ({ ref }),
        }
    }
});


const internalActions = createActions({
    FIREBASE: {
        DATABASE: {
            SET_DATA: (path, snapshot) => ({ path, key: snapshot.key, data: snapshot.val() }),
            UPDATE_DATA: (path, snapshot) => ({ path, key: snapshot.key, data: snapshot.val() }),
            DELETE_DATA: (path, snapshot) => ({ path, key: snapshot.key }),
        }
    }
});

export const firebaseDbReducer = handleActions({
    [internalActions.firebase.database.setData]: (state, { payload: { path, key, data }}) => {
        if (data !== null && key !== null) {
            const paths = path.split('/');
            paths.push(key);
            return state.setIn(paths, fromJS(data));
        }
        return state;
    },
    [internalActions.firebase.database.updateData]: (state, { payload: { path, key, data }}) => {
        if (data !== null && key !== null) {
            const paths = path.split('/');
            const part = state.getIn(paths) || fromJS({});
            return state.setIn(paths, part.mergeDeep(data));
        }
        return state;
    },
    [internalActions.firebase.database.deleteData]: (state, { payload: { path, key } }) => {
        if (key !== null) {
            const paths = path.split('/');
            paths.push(key);
            return state.deleteIn(paths);
        }
        return state;
    },
}, fromJS(defaultState));


export const createFirebaseDbMiddleware = (firebase) => {
    const db = firebase.database();

    const actions = dbActions.firebase.database;
    const internal = internalActions.firebase.database;

    return store => next => action => {
        const { payload } = action;

        function dispatchSnapshot(actionCreator) {
            return (snapshot) => {
                store.dispatch(actionCreator(payload.ref, snapshot));
                return snapshot;
            };
        }

        switch (action.type) {
            case actions.get.toString():
                return applyOptions(db.ref(payload.ref), payload.options)
                    .once('value')
                    .then(snapshot => {
                        snapshot.forEach(dispatchSnapshot(internal.setData));
                        return snapshot;
                    });
            case actions.subscribe.toString():
                const subRef = applyOptions(db.ref(payload.ref), payload.options);
                subRef.on('child_added', dispatchSnapshot(internal.setData));
                subRef.on('child_changed', dispatchSnapshot(internal.setData));
                subRef.on('child_removed', dispatchSnapshot(internal.deleteData));
                return Promise.resolve();
            case actions.unsubscribe.toString():
                db.ref(payload.ref).off();
                return Promise.resolve();

            default:
                return next(action);
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/modules/firebase/databaseModule.js